export default Object.freeze({
  user: 'user',
  expert: 'expert',
  mainExpert: 'mainExpert'
})
